import { Directive, Input } from '@angular/core';
import { BlockLang, LocalizedText, localizedText } from 'src/app/core/models/message-blocks';

/**
 * Base for every block sub-component. Carries the active language and a `t()`
 * helper to resolve LocalizedText in templates. The concrete sub-component adds
 * its own typed `@Input() block`.
 */
@Directive()
export abstract class MessageBlockBaseDirective {
  @Input() lang: BlockLang = 'en';

  /** Resolve a LocalizedText to a plain string in the active language. */
  t(value?: LocalizedText): string {
    return localizedText(value, this.lang);
  }
}
